import ReactCountryFlag from "react-country-flag";
import { useParams } from "react-router-dom";

export default function LangButton({lang, title, flag}) {
    
    const params = useParams();

    function changeLanguage(e) {
        if (params.lang !== undefined) {
            window.location.href = window.location.href.replace('/'+params.lang, '/'+lang);
        } else {
            window.location.href = '/' + lang;
        }
    }

    return (
        <button onClick={changeLanguage}><ReactCountryFlag countryCode={flag} svg style={{ width: '25px', height: '13px' }} /> {title}</button>
    )
    
}